import React from 'react';
export const ErrorIcon = () => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.13 2.5l-9.26 16a1 1 0 00.87 1.5h18.52a1 1 0 00.87-1.5l-9.26-16a1 1 0 00-1.74 0zM12 9a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm0 7a1 1 0 100 2 1 1 0 000-2z"
}));